export const iconFontAwesomeBuildingsHouseMedical = (
	<i className="fa-solid fa-house-medical"></i>
);
